import React, { useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel, Tab, Table, TableBody, TableCell,
  TableContainer,
  TableHead, TableRow,
  TextField,
  Paper
} from "@mui/material";


const cssInJs = {
  header: {
    backgroundColor: "#fff",
  },
  grayBlock: {
    background: '#fafafa',
    padding: '10px',
  },
  textInput: {
    marginRight: '20px',
    marginBottom: '15px'
  },
  formControl: {
    minWidth: 80,
    marginRight: '20px',
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}
function JobLog({ selectedFlightJobLog }) {
  const [loading, setLoading] = React.useState();

  function generateUniqueId() {
    return new Date().getTime().toString(36);
  }

  useEffect(() => {
    console.log(selectedFlightJobLog, 'selected flight job log')
  });

  return (
    <Card>
      <CardHeader
        title={'Job Log'}
        sx={{
          ...cssInJs.header,
          '&.MuiTypography-root': {
            fontSize: '16px',
          },
        }}
      />
      <CardContent component={Paper}>
        <TableContainer>
          <Table className="material-table">
            <TableBody>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>{selectedFlightJobLog.is_success ?? ''}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Result</TableCell>
                <TableCell>{selectedFlightJobLog.result ?? ''}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Job</TableCell>
                <TableCell>{selectedFlightJobLog?.job_type_id || 'N/A'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Period</TableCell>
                <TableCell>{selectedFlightJobLog?.period || 'N/A'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Duration</TableCell>
                <TableCell>{selectedFlightJobLog?.duration || '0'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total Duration</TableCell>
                <TableCell>{selectedFlightJobLog?.totalDuration || '0'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Queue</TableCell>
                <TableCell>{selectedFlightJobLog?.queue || '0'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Start</TableCell>
                <TableCell>{selectedFlightJobLog?.start_date || 'N/A'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>End</TableCell>
                <TableCell>{selectedFlightJobLog?.end || 'N/A'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>{selectedFlightJobLog?.id || 'N/A'}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}

export default JobLog;